module.exports = __webpack_public_path__ + "img/1-4.e098c8e9.svg";